import React, { useEffect, useState } from "react";
import TextField from "../../../components/inputs/textfield";
import Snackbar from "../../../components/snackbar/snackbar";
import Loader from "../../../components/loader/loader";
import { FormValidate } from "../../../components/formValidate";
import { admin_mous_add } from "../admin.api";
import "./view.css";
import CommonForm from "../../../components/commonform/commonForm";
let required = [
  "organization_name",
  "logo",
];
let fiveYearsAgo = new Date();
fiveYearsAgo.setFullYear(fiveYearsAgo.getFullYear() - 5, 0, 1);
const today = new Date();
const fiveYearsAfter = new Date(today.getFullYear() + 5, 11, 31);
const endOfYear = new Date(today.getFullYear(), 11, 31);

export default function AddMous(props) {
  const [formData, setFormData] = useState({
    member: true,
    head: false,
    governing_member: true,
    council_number: false,
  });

  const [snackMessage, setSnackMessage] = useState("");
  const [fileChanged, setFileChanged] = useState(false);
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isSnackError, setIsSnackError] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [err, setErr] = useState(false);
  const [keyvalue, setKeyValue] = useState(1);

  const handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let data = formData;
    data = { ...data, [name]: value };
    setFormData(data);
  };

  const handlePhotoFileChange = (e) => {
    setIsActive(true);
    try {
      let flag = false;

      let type = e.target.files[0].name.split(".").pop();

      if (type === "png" || type === "jpeg" || type === "jpg") {
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;

          image.onload = function () {
            var height = this.height;
            var width = this.width;

            if (height === 400 || width === 400) {
              flag = true;
            }
          };
        };
        setTimeout(() => {
          if (flag) {
            setFileChanged(true);
            setFormData({
              ...formData,
              // file_name: e.target.files[0].name,
              [e.target.name]: e.target.files[0],
            });
            setIsActive(false);
          } else {
            setSnackMessage("Incorrect image dimension");
            setIsSnackError(true);
            setSnackOpen(true);
            setIsActive(false);
          }
        }, 2000);
      } else {
        setSnackMessage("File should be in .jpg / .jpeg / .png format");
        setIsSnackError(true);
        setSnackOpen(true);
        setIsActive(false);
      }
    } catch {
      setIsActive(false);
    }
  };
  const handleDatePickerChange = (e, name) => {
    let date = e.value;
    const dateRegex = /^[0-9]{2}-[0-9]{2}-[0-9]{4}$/;
    if (dateRegex.test(date)) {
      setErr(false);
    } else {
      setErr(true);
    }
    setFormData({ ...formData, [name]: date });
    setKeyValue(keyvalue + 1);
  };



  const handleSubmit = (e) => {
    e.preventDefault();
    if (isActive) return;
    setIsActive(true);
    const errors = FormValidate(formData, required);
    if (Object.keys(errors).length === 0) {
      const form = new FormData();
      form.append("organization_name", formData?.organization_name);
      formData?.kspace_signatory_area && form.append("kspace_signatory_area", formData?.kspace_signatory_area);
      formData?.partner_signatory_area && form.append("partner_signatory_area", formData?.partner_signatory_area);
      form.append("logo", formData?.logo);
      const [day, month, year] = formData.from_date.split("-");
      form.from_date = `${year}-${month}-${day}`;
      form.append("from_date", form?.from_date);

      const [day1, month1, year1] = formData.to_date.split("-");
      form.to_date = `${year1}-${month1}-${day1}`;
      form.append("to_date", form?.to_date);

      form.append("status", 0);

      admin_mous_add(form)
        .then((res) => {
          setSnackMessage(res.message);
          setIsSnackError(false);
          setSnackOpen(true);
          setIsActive(false);
        })
        .catch((error) => {
          setSnackMessage(error.message);
          setIsSnackError(true);
          setSnackOpen(true);
          setIsActive(false);
        });
    } else {
      setSnackMessage("Please fill all mandatory fields");
      setIsSnackError(true);
      setSnackOpen(true);
      setIsActive(false);
    }
  };

  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.history.push("/admin-mou");
    }
  };

  return (
    <div className="add-per">
      <Snackbar
        message={snackMessage}
        error={isSnackError}
        open={snackOpen}
        close={snackbarClose}
      />
      <Loader open={isActive} />
      <div className="view-container">
        <h6>
          <b>Add MOU</b>
        </h6>
        <hr />
        <div className="row">
          <div className="col-12">
            <TextField
              fullwidth
              label="Organization"
              value={formData.organization_name ?? ""}
              onChange={(e) => handleChange(e)}
              name="organization_name"
              id="organization_name"
              aria-describedby="emailHelp"
              required
            />
          </div>
          <div className="col-12">
            <TextField
              fullwidth
              label="Signatory from KSPACE"
              value={formData.kspace_signatory_area ?? ""}
              onChange={(e) => handleChange(e)}
              name="kspace_signatory_area"
              id="kspace_signatory_area"
              multiline
              aria-describedby="emailHelp"
            />
          </div>
          <div className="col-12">
            <TextField
              type="text"
              label="Signatory from partner organization"
              value={formData.partner_signatory_area ?? ""}
              onChange={(e) => handleChange(e)}
              name="partner_signatory_area"
              id="partner_signatory_area "
              multiline
              aria-describedby="emailHelp"
            />
          </div>
          <div className="col-12">
            <TextField
              label="Logo"
              id="formFileSm"
              onChange={(e) => handlePhotoFileChange(e)}
              accept=".jpg,.jpeg,.png"
              name="logo"
              type="file"
              required
            />
            <small className="pers">
              *Upload only .jpg , .jpeg , .png format and Size should be less
              than 1MB of width: 400 Height: 400
            </small>
          </div>
          <div className="col-12">

            <CommonForm
              fieldType="date"
              label={`Date From `}
              required
              name="from_date"
              minDate={new Date(fiveYearsAgo)}
              maxDate={endOfYear}
              value={formData?.from_date ?? ""}
              onChange={(e) => {
                handleDatePickerChange(e, "from_date");
              }}
              {...props}
            />
            {err && (
              <div className="file-up-helper mt-1">
                Please select a valid date
              </div>
            )}
          </div>
          <div className="col-12 ">

            <CommonForm
              fieldType="date"
              label={`Date To `}
              required
              name="to_date"
              minDate={today}
              maxDate={fiveYearsAfter}
              value={formData?.to_date ?? ""}
              onChange={(e) => {
                handleDatePickerChange(e, "to_date");
              }}
              {...props}
            />
            {err && (
              <div className="file-up-helper mt-1">
                Please select a valid date
              </div>
            )}
          </div>

          <div className="col-12">
            <center>
              <button
                type="button"
                className="btn btn-dark mt-3"
                onClick={(e) => handleSubmit(e)}
              >
                Submit for Acceptance
              </button>
            </center>
          </div>
          {/* ---------------- */}
        </div>
      </div>
    </div>
  );
}
